import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const visitDispatchNoteCreateV1Schema = z.object({
  noteId: entityIdSchema,
  visitId: entityIdSchema,
  visitVersion: z.number().int().positive(),
  body: z.string().trim().min(1).max(2_000),
  capturedAt: z.iso.datetime({ offset: true }),
}).strict()

export type VisitDispatchNoteCreateV1 = z.infer<typeof visitDispatchNoteCreateV1Schema>
